<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="6">
						<el-form-item>
							<el-input style="width:200px;margin-right: 10px;" placeholder="请输入关键字" v-model="keyword" size="small" clearable></el-input>
							<el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="2" >
						<el-form-item label="" :label-width="'0px'">
							<el-checkbox v-model="containStop" @change="changeSearch">含已停用</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="排序" :label-width="'50px'">
							<el-select style="width:130px" v-model="desc" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{value:true,label:'时间由近及远'},{value:false,label:'时间由远及近'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="" :label-width="'50px'">
							<el-popover placement="bottom" title="" width="500" trigger="click" v-model="screenState">
								<el-button type="warning" slot="reference" size="small">筛选</el-button>
								<div class="screenBoxSignatureFileList">
									<div class="screenLine">
										<div class="screenLabel">业务分类:</div>
										<div class="screenValue">
											<div class="screenItem" :class="[type.indexOf(item.id)>-1?'active':'']" @click="clickType(item)" v-for="(item,index) in $types.fileTemplate_type" :key="index">{{item.name}}</div>
										</div>
										<div class="screenType">(多选)</div>
									</div>
									<div class="screenLine">
										<div class="screenLabel">创建时间:</div>
										<div class="screenValue">
											<el-date-picker v-model="createTime" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" style="width:250px;" @change="changeCreateTime">
											</el-date-picker>
										</div>
									</div>
									<!-- <div class="screenBtnLine">
										<el-button slot="reference" size="mini">取消</el-button>
										<el-button type="primary" slot="reference" size="mini" @click="closeScreen">确定</el-button>
									</div> -->
								</div>
							</el-popover>
						</el-form-item>
					</el-col>
					<el-col :span="2" :offset="5">
						<el-form-item label="" :label-width="'0px'">
							<el-button type="warning" size="small" @click="down">下载</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="2" >
						<el-form-item label="" :label-width="'0px'">
							<el-button type="warning" size="small" @click="clickUploadTemplate">上传模板</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="序号" width="100">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column>
				<el-table-column label="业务类型" prop="id">
					<template slot-scope="props">
						{{$types.get_fileTemplate_type(props.row.contractType)}}
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="medicalServiceName">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm:ss')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="创建人" prop="createUserName">
				</el-table-column>
				<el-table-column label="签署份数" prop="signCount">
				</el-table-column>
				<el-table-column label="是否使用印章" prop="petName">
					<template slot-scope="props">
						<div v-if="$public.isNull(props.row.sealId)">否</div>
						<div v-else>{{props.row.sealName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="模板状态" prop="petName">
					<template slot-scope="props">
						<div v-if="props.row.state===1">已启用</div>
						<div v-if="props.row.state===2">已停用</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" >
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-if="props.row.state===1" type="text" size="mini" @click="changeTemplateState(props.row)">停用</el-button>
						<el-button v-if="props.row.state===2" type="text" size="mini" @click="changeTemplateState(props.row)">启用</el-button>
						<el-button v-if="props.row.state===2" type="text" size="mini" @click="deleteTemplateState(props.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="dialogUploadTemplate_state">
			<uploadTemplate @submit="submit_uploadTemplate"></uploadTemplate>
		</div>
		<div v-if="pdfUrl.length>0">
			<pdf :src="pdfUrl"></pdf>
		</div>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	import uploadTemplate from "./comp_uploadTemplate.vue"
	import pdf from "vue-pdf"
	export default {
		components:{page,uploadTemplate,pdf},
		data(){
			return{
				// 上传
				dialogUploadTemplate_state:false,
				
				keyword:'',
				containStop:true,
				desc:true,
				screenState:false,
				type:[],
				createTime:'',
				
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 下载 
				downList:[],
				// 查看
				pdfUrl:'',
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get('/api/Contract/Detail', {id:row.id}).then(res => {
					loading.close()
					if (res.code == 0) {
						// this.pdfUrl = res.data.contractPdfUrl;
						window.open(res.data.contractPdfUrl)
					}
				})
			},
			// 上传模板
			clickUploadTemplate(){
				this.dialogUploadTemplate_state = true;
			},
			submit_uploadTemplate(obj){
				this.dialogUploadTemplate_state = false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			// 筛选
			changeSearch(){
				this.page.page = 1;
				this.getTableData();
			},
			closeScreen(){
				this.screenState=false;
			},
			clickType(item){
				let index = -1;
				for(let i=0;i<this.type.length;i++){
					if(this.type[i]===item.id){
						index=i
					}
				}
				if(index===-1){
					this.type.push(item.id)
				}else{
					this.type.splice(index,1)
				}
				this.page.page = 1;
				this.getTableData();
			},
			changeCreateTime(){
				this.page.page = 1;
				this.getTableData();
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"contractType": this.type,  // 合同类型
					"sealType": 0,  // 印章类型
					"beginTime": "",  // 开始时间
					"endTime": "",  // 结束时间
					"desc":this.desc,
					"containStop": this.containStop,  // 是否包含停用合同
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.keyword,
				}
				if(this.createTime&&this.createTime.length===2){
					params.beginTime=(''+new Date(this.createTime[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.createTime[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post('/api/Contract/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 修改启停状态
			changeTemplateState(row){
				this.$confirm('确定要'+(row.state===1?'停用':'启用')+'该模板吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/Contract/Update', {id:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 删除
			deleteTemplateState(row){
				this.$confirm('确定要删除该模板吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/Contract/Delete', {id:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 下载
			handleSelectionChange(val) {
				this.downList = val;
			},
			down(){
				if(this.downList.length===0){
					this.$message({
						message: '请选择要下载的文件',
						type: 'error'
					});
					return ;
				}
				for(let i=0;i<this.downList.length;i++){
					const iframe = document.createElement("iframe");
					iframe.style.display = "none"; 
					iframe.style.height = 0; 
					iframe.src = this.downList[i].contractUrl;
					document.body.appendChild(iframe);
					setTimeout(()=>{
						iframe.remove();
					},100000);
				}
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.tableBox{
		min-height: 600px;background-color: #fff;margin-top: 12px;
	}
	
}
</style>
<style lang="scss">
	.screenBoxSignatureFileList{
		.screenLine{
			display: flex;padding:5px 0;
			.screenLabel{
				font-size: 14px;color:#2A2A2A;width:70px;flex-grow: 0;flex-shrink: 0;line-height: 24px;
			}
			.screenValue{
				display: flex;
				.screenItem{
					padding:0 10px;box-sizing: border-box;height: 24px;line-height: 22px;text-align: center;margin-right: 15px;border:1px solid rgba(0, 0, 0, 0.15);border-radius: 2px;background-color: #fff;font-size: 14px;cursor: pointer;
					&.active{
						color:#fff;background-color: $mainColor;border-color:$mainColor;
					}
				}
			}
			.screenType{
				font-size: 14px;color:#2A2A2A;width:50px;flex-grow: 0;flex-shrink: 0;
			}
		}
		.screenBtnLine{
			text-align: right;padding-top:10px;margin-top:10px;border-top:1px solid rgba(0, 0, 0, 0.06);
		}
	}
</style>
